import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../context/auth';
import { Mensaje } from '../components/mensajes2';
import Header2 from '../components/Header2';
import moment from 'moment';
import { Toasts } from '../components/toasts';
import logo2 from '../imagenes/logo33.png'
import logo3 from '../imagenes/logo333.png'
import logo1 from '../imagenes/opensiii.jpg'
import SeleccionarNomina from '../components/nomina/Opciones/SeleccionarNomina/seleccionarNomina';
import axios from "axios";
import { VerConfiguracion } from '../components/configuracionGeneral/modalConfigGeneral';

function Inicio(props) {
	const [mostrar2, setMostrar2] = useState(false);

	let op = require('../../src/modulos/datos');
	let token = localStorage.getItem('jwtToken');
	const [toast, setToast] = useState({
		mostrar: false,
		mensaje: '',
		titulo: ''
	});
	const [mensaje, setMensaje] = useState({
		mostrar: false,
		titulo: "",
		texto: "",
		icono: "",
	});
	const { user } = useContext(AuthContext);
	const [mostrar3, setMostrar3] = useState(false);
	const [inicio, setInicio] = useState(false);
	const [msg] = useState('');
	const [titulo] = useState('');
	const [mostrar, setMostrar] = useState(false);
	const [mostrar1, setMostrar1] = useState(false);
	const accaplicacion = JSON.parse(localStorage.getItem('accaplicacion'));
	localStorage.setItem('llamado', '');
	useEffect(() => {

		if (localStorage.getItem('efiseleccionado') === 'true') {
			setMostrar3(false);
			setInicio(false);
		} else {
			setMostrar3(true);
			setInicio(true);
		}
		localStorage.setItem('idalmacen', JSON.stringify('0'));
		localStorage.setItem('almacendes', JSON.stringify(''));
		localStorage.setItem('almacebseleccionado', false);

	}, []);

	const seleccionar = (pathname, permiso) => (event) => {
		event.preventDefault();
		if (permiso === '1') {
			if (pathname === '/seleccionarNomina') {
				setMostrar1(true);
			} else {
				props.history.push(pathname);
			}
		} else {
			setToast({
				mostrar: true,
				mensaje: 'Su usuario no tiene permiso para este modulo.',
				titulo: 'Alerta.'
			})

		}

	}

	const cerrarSeleccionarNomina = (msg) => {
		setMostrar1(false);
		if (msg !== '') {
			setMensaje({
				mostrar: true,
				titulo: "ERROR",
				texto: msg,
				icono: "error",
			});
		}
		props.history.push("/inicio");
	};

	const aceptarSeleccionarNomina = () => {
		setMostrar1(false);
		let body = {
			nomusu: JSON.parse(localStorage.getItem("post")).login,
			nomper: JSON.parse(localStorage.getItem('liquidador')),
			fechasis: JSON.parse(localStorage.getItem('fechasistema')),
			codnomi: JSON.parse(localStorage.getItem('codigonomina')),
			titnomi: JSON.parse(localStorage.getItem('titulonomina'))
		};
		actualizarValores(body);
		actualizarConfig();
		activarTrabajadores();
		props.history.push("/nomina");
	};

	const actualizarValores = (body) => {
		//setActivate(true);
		let endpoint = `${op.conexion}/api/nomina/actualizarvalores`;
		axios
			.post(endpoint, body, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				//setActivate(false);
				if (response.status == 200) {

				} else {

				}

			})
			.catch(function (error) {
				actualizarConfig	/*setMensaje({
						mostrar: true,
						titulo: "ERROR",
						texto: error.response.data.message,
						icono: "error",
					});*/
				//setActivate(false);
			});
	};

	const actualizarConfig = () => {
		//setActivate(true);
		let endpoint = `${op.conexion}/api/nomina/actualizarconfig/${JSON.parse(localStorage.getItem('codigonomina'))}`;
		axios
			.post(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				//setActivate(false);
				if (response.status == 200) {
					localStorage.setItem('numsemana', response.data.numper);
				} else {

				}

			})
			.catch(function (error) {
				/*setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});*/
				//setActivate(false);
			});
	};

	const activarTrabajadores = () => {

		let body = {
			codnomi: JSON.parse(localStorage.getItem('codigonomina')),
			fechanomi: JSON.parse(localStorage.getItem('fechanomina'))
		};

		let endpoint = `${op.conexion}/api/nomina/activartrabajadores`;
		axios
			.post(endpoint, body, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				//setActivate(false);

			})
			.catch(function (error) {
				/*setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});*/
				//setActivate(false);
			});
	};

	const cerrarToast = () => {
		setToast({
			...toast,
			mostrar: false
		})
	}
	const handleCloseMensa = () => {
		setMostrar(false);
	}

	return (
		user && op.admin === 0 ? (
			<div id='inicio' style={{
				height: "100vh",
			}}>
				<div className="col-md-12" style={{ padding: 0, backgroundColor: "#007bff" }}>
					<Header2 />
				</div>
				<div className='container'>
					<div className='container row col-md-12 py-3' style={{ padding: 0, margin: 0 }}>
						<img src={logo2} className="imagens" />
						<div className='col-md-3 col-6 col-sm-6'>
							<div className='col-md-12 col-6 mt-3'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#acd6fb', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/contabilidadPresupuestaria', accaplicacion.substring(0, 1))}>
									<i className="fas fa-calculator bg-light fs-1 second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
									<div>
										<p className="fw-bold">Contabilidad Presupuestaria</p>
									</div>
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/administracion', accaplicacion.substring(1, 2))}>
									<i className="fas fa-chalkboard bg-light fs-1 second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
									<div>
										<p className="fw-bold">Administración y Tesorería</p>
									</div>
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#233671', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/comprasyAlmacen', accaplicacion.substring(4, 5))}>
									<i className="fas fa-dolly fs-1 bg-light second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
									<div className=''>
										<p className="fw-bold text-warning">Compra y Almacen</p>
									</div>
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/contafiscal', accaplicacion.substring(3, 4))}>
									<i className="fas fa-cash-register bg-light fs-1 second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
									<div>
										<p className="fw-bold">Contabilidad Físcal</p>
									</div>
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#add6fa', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/bienesMunicipales', accaplicacion.substring(5, 6))}>
									<i className="fas fa-car-side fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
									<div className=''>
										<p className="fw-bold">Bienes Municipales</p>
									</div>
								</button>
							</div>
						</div>
						<div className='col-md-6 prue'>
							<figure className="figure rounded-circle" id="central">
								<div className="image-border-container">
									<img  src={op.imagenes + '/imagen?img=' + op.logologin}  className="logo-image2" alt="Logo" />
								</div>
							</figure>
						</div>
						<div className='col-md-3 col-6 col-sm-6'>
							<div className='col-md-12 col-6 mt-3'>
								<button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#acd6fb', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/catastro', accaplicacion.substring(7, 8))}>
									<div className=''>
										<p className="fw-bold">Catastro</p>
									</div>
									<i className="fas fa-building fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/haciendaMunicipal', accaplicacion.substring(6, 7))}>
									<div className=''>
										<p className="fw-bold">Hacienda Municipal</p>
									</div>
									<i className="fas fa-university fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#233671', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/seleccionarNomina', accaplicacion.substring(8, 9))}>
									<div className=''>
										<p className="fw-bold text-warning">Nómina</p>
									</div>
									<i className="fas fa-money-bill-wave bg-light fs-1 second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/ingenieria', accaplicacion.substring(2, 3))}>
									<div>
										<p className="fw-bold text-start">Ingenieria Municipal</p>
									</div>
									<i className="fas fa-snowplow bg-light fs-1 second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#add6fa', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/gestionControl', accaplicacion.substring(9, 10))}>
									<div className=''>
										<p className="fw-bold">Gestión y Control</p>
									</div>
									<i className="fas fa-chalkboard-teacher bg-light fs-1 second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
								</button>
							</div>
						</div>
					</div>


				</div>
				<Mensaje
					mensaje={mensaje}
					onHide={() => {
						setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
					}}
				/>
				<footer className="container-fluid text-center fixed-botton fixed-bottom" id=''>
					<img src={op.imagenes + '/imagen?img=Logopsiap.png'} style={{ width: '120px' }} alt="footer" />
					<strong>Copyright &copy; {moment.utc().format('YYYY')} <a className='bluez-text' href="http://www.opensiap.com.ve" target="_blank">SYGRECA.</a>Todos los Derechos Reservados.</strong>
				</footer>
				<Toasts
					show={toast.mostrar}
					titulo={toast.titulo}
					mensaje={toast.mensaje}
					onHideCancela={cerrarToast}
				/>
				<SeleccionarNomina
					show={mostrar1}
					llamado={0}
					onHideCancela={cerrarSeleccionarNomina}
					onHideAcepta={aceptarSeleccionarNomina}
				/>
			</div>
		)

			: <div id='inicio' style={{
				height: "100vh",
			}}>
				<div className="col-md-12" style={{ padding: 0, backgroundColor: "#007bff" }}>
					<Header2 />
				</div>
				<div className='container'>
					<div className='container row col-md-12 py-3' style={{ padding: 0, margin: 0 }}>
						<img src={logo3} className="imagens" />
						<div className='col-md-3 col-6 col-sm-6'>
							<div className='col-md-12 col-6 mt-3' style={{ visibility: 'collapse' }}>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#acd6fb', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/contabilidadPresupuestaria', accaplicacion.substring(0, 1))}>
									<i className="fas fa-calculator bg-light fs-1 second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
									<div>
										<p className="fw-bold">Contabilidad Presupuestaria</p>
									</div>
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/contabilidadPresupuestaria', accaplicacion.substring(0, 1))}>
									<i className="fas fa-calculator bg-light fs-1 second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
									<div>
										<p className="fw-bold">Contabilidad Presupuestaria</p>
									</div>
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#233671', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/administracion', accaplicacion.substring(1, 2))}>
									<i className="fas fa-chalkboard fs-1 bg-light second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
									<div className=''>
										<p className="fw-bold text-warning">Administración y Tesorería</p>
									</div>
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/comprasyAlmacen', accaplicacion.substring(4, 5))}>
									<i className="fas fa-dolly bg-light fs-1 second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
									<div>
										<p className="fw-bold ">Compra y Almacen</p>
									</div>
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#add6fa', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/contafiscal', accaplicacion.substring(3, 4))}>
									<i className="fas fa-cash-register  fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
									<div className=''>
										<p className="fw-bold">Contabilidad Físcal</p>
									</div>
								</button>
							</div>
						</div>
						<div className='col-md-6 prue'>
							<figure className="figure rounded-circle" id="central">
								<div className="image-border-container">
									<img  src={op.imagenes + '/imagen?img=' + op.logologin}  className="logo-image2" alt="Logo" />
								</div>
							</figure>
						</div>
						<div className='col-md-3 col-6 col-sm-6'>
							<div className='col-md-12 col-6 mt-3' style={{ visibility: 'collapse' }}>
								<button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#acd6fb', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/catastro', accaplicacion.substring(7, 8))}>
									<div className=''>
										<p className="fw-bold"></p>
									</div>
									<i className="fas fa-building fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/bienesMunicipales', accaplicacion.substring(5, 6))}>
									<div className=''>
										<p className="fw-bold">Bienes Municipales</p>
									</div>
									<i className="fas fa-car-side fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#233671', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/seleccionarNomina', accaplicacion.substring(8, 9))}>
									<div className=''>
										<p className="fw-bold text-warning">Nómina</p>
									</div>
									<i className="fas fa-money-bill-wave bg-light fs-1 second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "180px" }} onClick={seleccionar('/gestionControl', accaplicacion.substring(9, 10))}>
									<div>
										<p className="fw-bold ">Gestión y Control</p>
									</div>
									<i className="fas fa-chalkboard-teacher  bg-light fs-1 second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
								</button>
							</div>
							<div className='col-md-12 col-6 mt-5'>
								<button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#add6fa', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "180px" }} onClick={() => { setMostrar2(true) }} >
									<p className="fw-bold text-start">Configuración General</p>
									<i className="fas fa-chalkboard-teacher bg-light fs-1 second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
								</button>
							</div>
						</div>
					</div>


				</div>
				<Mensaje titulo={titulo} mensaje={msg}
					show={mostrar}
					onHide={handleCloseMensa} />
				<footer className="container-fluid text-center fixed-botton fixed-bottom" id=''>
					<img src={op.imagenes + '/imagen?img=Logopsiap.png'} style={{ width: '120px' }} alt="footer" />
					<strong>Copyright &copy; {moment.utc().format('YYYY')} <a className='bluez-text' href="http://www.opensiap.com.ve" target="_blank">SYGRECA.</a>Todos los Derechos Reservados.</strong>
				</footer>
				<Toasts
					show={toast.mostrar}
					titulo={toast.titulo}
					mensaje={toast.mensaje}
					onHideCancela={cerrarToast}
				/>
				<SeleccionarNomina
					show={mostrar1}
					llamado={0}
					onHideCancela={cerrarSeleccionarNomina}
					onHideAcepta={aceptarSeleccionarNomina}
				/>

				<VerConfiguracion
					show={mostrar2}
					onHideCancela={() => { setMostrar2(false) }}
				/>
			</div>
	);
}


export default Inicio;
